var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header"},[_c('img',{attrs:{"src":_vm.header.mouserlogo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }